"use client";
import { Image as ImageType } from "../../use-cases/contracts/Image";
import React from "react";
import dynamic from "next/dynamic";

import "react-image-gallery/styles/image-gallery.css";
// Lazy-load react-image-gallery – keeps it out of the initial JS bundle
// @ts-ignore
const ImageGallery = dynamic(() => import("react-image-gallery"), {
  ssr: false,
  loading: () => (
    <div className="aspect-square bg-gray-100 animate-pulse rounded-sm" />
  ),
});

export const ImageSlider: React.FC<{ images: ImageType[] }> = ({ images }) => {
  const images2 =
    images?.map((img) => ({
      original: img.variants[img.variants.length - 1]?.url,
      thumbnail: img.variants[0]?.url,
    })) ?? [];

  const GalleryAny = ImageGallery as any;
  return (
    <GalleryAny
      items={images2}
      showFullscreenButton={false}
      showPlayButton={false}
    />
  );
};
